export type EmployeeProfilesListTranslation = {
  content: {
    table: {
      department: string;
      firstName: string;
      lastName: string;
      position: string;
      region: string;
      regionArea: string;
      regionDistrict: string;
      sap: string;
    };
  };
  form: {
    button: {
      downloadDevelopmentPlans: string;
    };
    departments: string;
    firstName: string;
    lastName: string;
    myTeamOnly: string;
    positions: string;
    regionAreas: string;
    regionDistricts: string;
    regionsSelect: {
      east: string;
      headquarter: string;
      selectAll: string;
      south: string;
      west: string;
    };
    sap: string;
  };
  noViewPermission: string;
};

export const employeeProfilesListTranslation: EmployeeProfilesListTranslation = {
  content: {
    table: {
      department: 'Department',
      firstName: 'First Name',
      lastName: 'Last Name',
      position: 'Position',
      region: 'Region',
      regionArea: 'District',
      regionDistrict: 'Area',
      sap: 'SAP',
    },
  },
  form: {
    button: {
      downloadDevelopmentPlans: 'Download development plans',
    },
    departments: 'Departments',
    firstName: 'First Name',
    lastName: 'Last Name',
    myTeamOnly: 'My Team Only',
    positions: 'Positions',
    regionAreas: 'Districts',
    regionDistricts: 'Area',
    regionsSelect: {
      east: 'East',
      headquarter: 'Headquarter',
      selectAll: 'Select All',
      south: 'South',
      west: 'West',
    },
    sap: 'SAP',
  },
  noViewPermission: 'No permission to view profile',
};
